export const currencyFormatterWithDecimals = (
  value: number,
  decimalPlaces?: number,
): string => {
  let returnItem: string = '';

  if (!decimalPlaces) {
    decimalPlaces = 0;
  }

  if (value !== null && value !== undefined) {
    returnItem = parseFloat(value.toString().replace(/,/g, ''))
      .toFixed(decimalPlaces)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      .replace('NaN', '');
  }
  return returnItem;
};

export const roundOfNumber = (
  value: number,
  fractionDigits: number,
): number => {
  let returnItem: number = value;
  if (parseInt(String(value), 10) === parseFloat(String(value))) {
    returnItem = value;
  } else if (value) {
    returnItem = parseFloat(parseFloat(String(value)).toFixed(fractionDigits));
  }
  return returnItem;
};

export const timeDifferenceInYears = (dt1: string, dt2: string): number => {
  let diff = (new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
  diff /= 60 * 60 * 24;
  return Math.abs(Math.round(diff / 365.25));
};
export const truncateText = (str: string, length: number) => {
  let truncatedString: string = '';
  if (str && length) {
    truncatedString = str.substring(0, Math.min(length, str.length));
    truncatedString = truncatedString + (str.length > length ? '..' : '');
  } else {
    truncatedString = str;
  }
  return truncatedString;
};
